import {call, put, select} from "redux-saga/effects";
import {fetchQuestions} from "../actions";
import {IApplicationState} from "../../index";
import makeMap from "../../../shared/utils/makeMap";
import {IQuestionApiResponse} from "./types";
import makeForeignKey from "../../../shared/utils/makeForeignKey";
import apiCall from "../../../shared/utils/apiCall";
import {IQuestion} from "../types";
import {trackError} from "../../log/actions";
import {LogLevel} from "../../log/types";

export function mapQuestions(questions: IQuestion[]) {
    questions = questions.map(question => {
        for (let answer of question.answers) {
            (answer as any).questionId = question.id;
        }

        return question;
    });

    const [questionsWithAnswersForeignKey, answers] = makeForeignKey(questions, "answers", "id");
    const [questionsWithAuthorForeignKey, authors] = makeForeignKey(questionsWithAnswersForeignKey, "author", "id");

    const questionIds = questionsWithAuthorForeignKey.map(question => question.id);
    const answerIndex = makeMap(answers, "id");
    const questionIndex = makeMap(questionsWithAuthorForeignKey, "id");
    const authorIndex = makeMap(authors, "id");

    return {
        questionIds,
        questions: questionIndex,
        answers: answerIndex,
        authors: authorIndex,
    };
}

export default function* handleFetchQuestions() {
    try {
        const {unusedQuestions, unusedQuestionsFetchLanguage, uiLanguage, levelId} = yield select(({ settings, game, player }: IApplicationState) => ({
            unusedQuestions: game.unusedQuestions,
            unusedQuestionsFetchLanguage: game.unusedQuestionsFetchLanguage,
            uiLanguage: settings.general.uiLanguage,
            levelId: player.levelsCompleted + 1,
        }));

        if (unusedQuestions.length > 1 && unusedQuestionsFetchLanguage === uiLanguage) {
            return;
        }

        yield put(fetchQuestions.request());

        const response: IQuestionApiResponse = yield call(apiCall, {
            params: {
                section: "questions",
                method: "getAvailable",
                "context.levelId": levelId
            }
        });

        const {questions, answers, authors, questionIds} = mapQuestions(response.data);

        yield put(fetchQuestions.success({
            questions,
            answers,
            authors,
            unusedQuestions: questionIds,
            languageChanged: unusedQuestionsFetchLanguage !== uiLanguage,
            unusedQuestionsFetchLanguage: uiLanguage
        }));
    } catch (error) {
        yield put(trackError({
            logLevel: LogLevel.Fatal,
            category: "FetchQuestions",
            message: "Failed to fetch available questions",
            error: error,
        }));

        yield put(fetchQuestions.success({}));
    }
}